/* eslint-disable arrow-body-style */
import * as React from "react";
import {Component} from "react";

import {observer} from "mobx-react";

import {Input} from "semantic-ui-react";

import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";

import {Project} from "../../models/project";
import {InputOnChangeData} from "semantic-ui-react/dist/commonjs/elements/Input/Input";


export interface ProjectSearchProps {
    auftragsverwaltung: Auftragsverwaltung;
    projects?: Project[] | null;
}

@observer
export class ProjectSearch extends Component<ProjectSearchProps, any> {
    autorunDisposers: any[] = [];

    constructor(props: ProjectSearchProps) {
        super(props);
        this.state = {
            value: this.props.auftragsverwaltung.ProjectStore.searchTerm || ""
        };

        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    componentDidMount(): void {}

    componentWillUnmount(): void {}

    render(): React.ReactElement | null {
        const { value} = this.state;

        return (
            <Input
                fluid
                placeholder="Projektname, Projektnummer..."
                onChange={this.handleSearchChange}
                value={value}
                size="mini"
                icon="search"
            />
            // <Search
            //     loading={loading}
            //     placeholder="Projektname, Projektnummer..."
            //     // onResultSelect={(e, data) =>
            //     //     this.setState({
            //     //         value: data.result.title
            //     //     })
            //     // }
            //     onSearchChange={this.handleSearchChange}
            //     results={results}
            //     value={value}
            //     //resultRenderer={resultRenderer}
            //     noResultsMessage="Kein Projekt gefunden."
            //     showNoResults={false}
            //     size="mini"
            // />
        );
    };

    handleSearchChange(event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData): void {
        const {auftragsverwaltung} = this.props;

        auftragsverwaltung.ProjectStore.searchTerm = data.value;

        this.setState({
            value: data.value
        });
    };

}
